import type { Meta, StoryObj } from "@storybook/react";

import { fakeBasicInfoSectionProps } from "@/__mocks__/profile/overview";
import type { BasicInfoSectionProps } from "@/ui/components/profile";
import { BasicInfoSection } from "@/ui/components/profile";
import { Box } from "@/ui/layout";
import type {
  Permission,
  UserPermissionsType,
} from "@/utils/profile/permissions.util";
import {
  getPermissionChecker,
  UserPermissionsTypes,
} from "@/utils/profile/permissions.util";

const AllPermissions = "all";

const StoryMeta: Meta<
  { permissionsProfile: "all" | UserPermissionsType } & BasicInfoSectionProps
> = {
  title: "Components/Profile/Basic Info",
  component: BasicInfoSection,
  argTypes: {
    chosenName: { control: "text" },
    firstName: { control: "text" },
    gender: { control: "text" },
    lastName: { control: "text" },
    permissionsProfile: {
      control: "select",
      options: [...Object.keys(UserPermissionsTypes), AllPermissions],
    },
    pronouns: { control: "object" },
  },
  args: {
    ...fakeBasicInfoSectionProps(),
    permissionsProfile: AllPermissions,
  },
  render: (props) => {
    const { permissionsProfile } = props;
    const userPermissions =
      permissionsProfile === AllPermissions
        ? (): Permission => "editAndView"
        : getPermissionChecker(UserPermissionsTypes[permissionsProfile]);

    return (
      <Box width="100%">
        <BasicInfoSection {...props} userPermissions={userPermissions} />
      </Box>
    );
  },
};

type Story = StoryObj<BasicInfoSectionProps>;

const Primary: Story = {};

export { Primary };
export default StoryMeta;
